import { purple3 } from 'approot/shared/styles/colours.style';
import { ttsGetTextBlockSelector } from './tts-get-text-block-selector';

export function ttsHighlightText(timeValue: number, previousTimeValue: number) {
  const wordElement = document.getElementById(`tts-${timeValue}`);
  if (wordElement) {
    wordElement.style.backgroundColor = purple3;
  }

  // reset highlight on previous element
  const previousElement = document.getElementById(`tts-${previousTimeValue}`);
  if (previousElement) {
    previousElement.style.backgroundColor = '';
  }
}

export function ttsClearHighlightText(id: string) {
  const parent = document.getElementById(ttsGetTextBlockSelector(id));
  const wordElements = parent?.querySelectorAll('.tts-word');
  wordElements?.forEach(element => {
    (element as HTMLElement).style.backgroundColor = '';
  });
}
